import { useMemo } from "react";
import { getPrintLayers } from "../../../evergis/core/print/getPrintLayers";
import { useProjectLayerInfos, useProjectLayers } from "../../../hooks/project/useProjectLayers";

export const usePrintLayers = () => {
  const projectItems = useProjectLayers();
  const { layerInfos } = useProjectLayerInfos();

  return useMemo(() => getPrintLayers(projectItems, layerInfos), [projectItems, layerInfos]);
};
